module.exports = __webpack_public_path__ + "static/img/gj008.d297d35.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/service/projectApplication/gj008.png
// module id = Khbv
// module chunks = 1